module.exports = __webpack_public_path__ + "static/2-new-50df82d6c4a5948d63ebc70d802646bd.jpg";